import { useCallback } from 'react';
import useProvidersList from './useProvidersList';
import { logger } from '../logger';

const log = logger();

const useClinicOperationHandlers = () => {
  // Use the existing useProvidersList hook to get the refetch function
  // Skip initial fetch since this hook is only for manual refetching
  const { refetch: refetchProviderList } = useProvidersList({
    skipInitialFetch: true,
  });

  /**
   * Handler for when a clinic is removed for a logged In Professional
   * Refreshes provider details by refetching from API
   */
  const handleClinicRemoved = useCallback(
    async (data) => {
      try {
        log.info('Clinic removed: ', data?.clinicName);

        // Refetch provider list from API
        await refetchProviderList();
      } catch (error) {
        log.error('Error handling clinic removal', error);
      }
    },
    [refetchProviderList],
  );

  return {
    onClinicRemoved: handleClinicRemoved,
  };
};

export default useClinicOperationHandlers;
